import { ActivatedRoute } from "@angular/router";
import { AIService } from "../services/ai.service";
import { StorageService } from "src/modules/base/shared/services/storage.service";
import { BaseService } from "src/modules/base/shared/services/base.service";

export default class AIDecorator {


    public aiService: AIService;
    public baseService: BaseService;
    public storageService: StorageService;
    public route: ActivatedRoute;
    public data: any;
    public className: String;
    public injector: any;

    constructor(route: ActivatedRoute, name: String, injector?) {
        this.route = route;
        this.className = name;
        this.injector = injector ? injector : null;
        this.storageService = injector.get(StorageService)
        this.baseService = injector.get(BaseService)
        
    }
    init() {
        console.log("AI Decorator Init");
    }
    beforeFilling(formData,config) {
        return formData
    }

    processFilter(filter,config) {
        return filter
    }
    afterFilling(formData,config) {
        
    }
    destroy() {
        console.log("Destroy");
    }
}